import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  useToast,
  useDisclosure,
  Box,
  Text,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import {
  getLabelPrintSourceCouriers,
  getMerchantLabelPrintSource,
  updateMerchantLabelPrintSource,
} from "../../../api/merchants";
import { Loader } from "components/Loader/loader";

const FALLBACK_COURIERS = ["Bosta", "ShipBlu", "J&T", "PDC"];

export function LabelPrintSource({ row }) {
  const finalRef = React.useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [openLoader, setOpenLoader] = useState(false);
  const [couriers, setCouriers] = useState([]);
  const [values, setValues] = useState({});

  const resetState = () => {
    setCouriers([]);
    setValues({});
  };

  const onCloseModal = () => {
    resetState();
    onClose();
  };

  const loadData = async () => {
    setOpenLoader(true);
    const couriersRes = await getLabelPrintSourceCouriers(toast);
    const list =
      couriersRes?.couriers?.length > 0
        ? couriersRes.couriers
        : FALLBACK_COURIERS;
    const current = (await getMerchantLabelPrintSource(row._id, toast)) || {};
    const nextValues = {};
    list.forEach((courier) => {
      nextValues[courier] = current[courier] === "courier" ? "courier" : "system";
    });
    setCouriers(list);
    setValues(nextValues);
    setOpenLoader(false);
  };

  const handelSubmit = async () => {
    if (!couriers.length) return;
    setOpenLoader(true);
    const res = await updateMerchantLabelPrintSource(row._id, values, toast);
    if (res) {
      toast({
        status: "success",
        title: "Success.",
        description: "Label print source updated successfully",
      });
      onCloseModal();
    }
    setOpenLoader(false);
  };

  useEffect(() => {
    if (isOpen) {
      loadData();
    }
  }, [isOpen]);

  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        <Text onClick={onOpen}>Label print source</Text>
      </Box>
      <Modal
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseModal}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Label print source{row?.name ? ` — ${row.name}` : ""}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Loader isLoading={openLoader} />
            {couriers.map((courier) => (
              <FormControl key={courier} mt={4}>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  {courier}
                </FormLabel>
                <RadioGroup
                  value={values[courier] || "system"}
                  onChange={(value) =>
                    setValues((prev) => ({ ...prev, [courier]: value }))
                  }
                >
                  <Stack direction="row">
                    <Radio value="system">System</Radio>
                    <Radio value="courier">Courier</Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
            ))}
          </ModalBody>
          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handelSubmit}
              size="sm"
              color={"white"}
              colorScheme="blue"
              isDisabled={openLoader || !couriers.length}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
